export default __webpack_public_path__ + "static/media/ciss-small.713b8c59.svg";